import { EHR_TOKEN, useStorage } from '@/libs/storage'

import { refreshToken } from '../plugins/firebase.plugin'
import useExpiration from './useExpiration'

const useToken = () => {
  const { setItem, getItem, removeItem } = useStorage(EHR_TOKEN)
  const { setExpirationDate, getExpirationDate, removeExpirationDate } =
    useExpiration()

  const getToken = async () => {
    if (isExpired()) {
      await refreshToken()
    }
    return getItem()
  }

  const hasToken = () => {
    return !!getItem()
  }

  const setToken = (token: string, expirationTime: string) => {
    setItem(token)
    setExpirationDate(expirationTime)
  }

  const removeToken = () => {
    removeItem()
    removeExpirationDate()
  }

  const isExpired = () => {
    const marginTime = 1000 * 60 * 5 // 5 minutes
    const expirationTimeDate = getExpirationDate()
    const now = new Date().getTime() + marginTime

    return expirationTimeDate < now
  }

  return {
    getToken,
    setToken,
    removeToken,
    hasToken
  }
}

export default useToken
